import { render, staticRenderFns } from "./top2.vue?vue&type=template&id=0d6216f2&scoped=true"
import script from "./top2.vue?vue&type=script&lang=js"
export * from "./top2.vue?vue&type=script&lang=js"
import style0 from "./top2.vue?vue&type=style&index=0&id=0d6216f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6216f2",
  null
  
)

export default component.exports